import { Action, creator } from 'src/config/rootAction';

export const SET_RELAXATION_RECORDING_LISTENED = 'SET_RELAXATION_RECORDING_LISTENED';
export type SetRelaxationRecordingListenedAction = Action<typeof SET_RELAXATION_RECORDING_LISTENED>;
export const setRelaxationRecordingListened = creator<SetRelaxationRecordingListenedAction>(
    SET_RELAXATION_RECORDING_LISTENED,
);

export type PsychologicalFirstAidAction = SetRelaxationRecordingListenedAction;
